module.exports = __webpack_public_path__ + "img/benefits_01.be1a7322.jpeg";